import React from "react";

export default function LoadingVirtualBooth() {
	return (<div className="m-auto">
		<h1 className="text-bold text-3xl flex items-center m-auto text-gray-500">
			<span className="spinner h-full w-20 inline-block" />&nbsp;Loading Session Room...
		</h1>
	</div>);
}